<template>
  <div class="kefu" v-if="kefuData">
    <div class="kefu-item online" v-if="kefuData.openCustomerServiceSystem">
      <!-- <img class="item-img" src="../../../static/img/kefu/kefu1.png" alt=""> -->
      <span class="item-img"></span>
      <div>在线<br>客服</div>
      <div class="online-box_bg">
        <div class="online-box">
          <div v-for="(element,index) in customerServiceSystemConfigs" :key="index" class="online-item" v-on:mouseenter="onMouseEnterOnline(index)" v-on:mouseleave="onMouseLeaveOnline(index)" @click="onlineClick(element)">
            <img class="kefu-system_item_img" :src="`data:image/png;base64,${element.logoImg}`">
            <div style="padding-left: 16px;">
              <div :style="{color: isHoveredIndex === index ? element.clickFontColor : element.defaultFontColor}">{{ element.name }}</div>
              <div style="color: #999999;">{{ element.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kefu-item phone" v-if="kefuData.openCustomerServicePhone">
      <!-- <img class="item-img" src="../../../static/img/kefu/phone1.png" alt=""> -->
      <span class="item-img"></span>
      <div>电话<br>咨询</div>
      <div class="phone-box"  v-on:mouseenter="onMouseEnterPhone" v-on:mouseleave="onMouseLeavePhone">
        <img :src='`data:image/png;base64,${customerServicePhoneConfig.logoImgPath}`' alt="">
        <span style="color: #333333; padding: 0px 10px;">{{ customerServicePhoneConfig.name }}</span>
        <span style="white-space: nowrap;" :style="{color: isHovered ? customerServicePhoneConfig.clickFontColor : customerServicePhoneConfig.defaultFontColor}">{{ customerServicePhoneConfig.phone }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/assets/js/api'
export default {
  data () {
    return {
      kefuData: null,
      isHovered: false,
      isHoveredIndex: -1,
      customerServicePhoneConfig: null,
      customerServiceSystemConfigs: null
    }
  },
  created () {
    setTimeout(() => {
      const showOnlineService = localStorage.getItem('showOnlineService')
      if (showOnlineService === '1') {
        this.getKefuData()
      }
    }, 1000)
  },
  methods: {
    getKefuData () {
      api.menu.getKefuSystemConfig().then(res => {
        this.kefuData = res.data.data
        this.customerServicePhoneConfig = res.data.data.customerServicePhoneConfig
        this.customerServiceSystemConfigs = res.data.data.customerServiceSystemConfigs
      })
    },
    onlineClick (element) {
      const currentUser = api.currentUser()
      const { projectNo, projectName, projectSource } = this.kefuData
      const parasm = {
        url: element.url,
        projectNo,
        projectName,
        projectSource
      }
      if (currentUser) {
        const { userName, orgName, loginName, cellPhone, companyName } = currentUser
        parasm.loginAccount = loginName
        parasm.fullName = userName
        parasm.customerPhone = cellPhone
        parasm.orgName = orgName
        parasm.company = companyName
        parasm.userName = userName
      }
      api.menu.getKefuSystemConfigUrl(parasm).then(res => {
        if (res.data.code == '0') {
           this.linkKefu(res.data.data)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    onMouseEnterOnline (index) {
      this.isHoveredIndex = index
    },
    onMouseLeaveOnline () {
      this.isHoveredIndex = -1
    },
    onMouseEnterPhone () {
      this.isHovered = true
    },
    onMouseLeavePhone () {
      this.isHovered = false
    },
    getParams (data) {
      let urlLink = ''
      Object.keys(data).forEach((item) => {
        if (data[item]) {
          const link = '&' + item + '=' + data[item]
          urlLink += link
        }
      })
      return urlLink
    },
    generateRandomNumber (val) {
      const num = val || 16
      let randomNumber = ''
      while (randomNumber.length < num) {
        randomNumber += Math.floor(Math.random() * num).toString(num)
      }
      return randomNumber
    },
    linkKefu (val) {
      var iWidth = 850
      var iHeight = 700
      // 获得窗口的垂直位置
      var iTop = (window.screen.availHeight - 30 - iHeight) / 2
      // 获得窗口的水平位置
      var iLeft = (window.screen.availWidth - 10 - iWidth) / 2
      window.open(val, 'newwindow', 'height=' + iHeight + ',width=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ', toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no')
      window.opener = null
    }
  }
}
</script>
<style scoped>
  .kefu {
    position: fixed;
    top: 60%;
    right: 0;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(41,72,152,0.16);
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    z-index: 9;
  }
  .kefu-item {
    width: 48px;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #333333;
    cursor: pointer;
    position: relative;
  }
  .kefu-item:hover {
    background: #2778FF;
    color: #FFFFFF;
  }
  .online .item-img {
    width: 24px;
    height: 24px;
    background: url("../../../static/img/kefu/kefu1.png") no-repeat;
  }
  .online:hover .item-img {
    background: url("../../../static/img/kefu/kefu.png") no-repeat;
  }
  .online-box:before, .online-box:after {
    content: "";
    display: block;
    border-width: 10px;
    position: absolute;
    right: 2px;
    top: 105px;
    border-style: dashed solid solid dashed;
    border-color: transparent transparent transparent #fff;
    font-size: 0;
    line-height: 0;
    }
  .online-box_bg {
    position: absolute;
    right: 40px;
    top: -75px;
    padding-right: 20px;
    display: none;
  }
  .online-box {
    width: max-content;
    background: #FFFFFF;
    border-radius: 2px 2px 2px 2px;
    padding: 8px;
    box-shadow: 0px 0px 16px 0px rgba(41,72,152,0.16);
  }
  .online:hover .online-box_bg {
    display: block;
    align-items: center;
  }
  .online-item {
    display: flex;
    align-items: center;
    width: 226px;
    height: 48px;
    background: #FAFAFA;
    border-radius: 2px 2px 2px 2px;
    margin-bottom: 8px;
    padding: 10px 0 8px 16px;
  }
  .online-item:last-child {
    margin-bottom: 0px;
  }
  .phone-box {
    position: absolute;
    right: 60px;
    top: 15px;
    height: 48px;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(41,72,152,0.16);
    border-radius: 2px;
    line-height: 48px;
    padding: 0 24px;
    white-space: nowrap;
    display: none;
  }
  .phone-box:before, .phone-box:after {
    content: "";
    display: block;
    border-width: 10px;
    position: absolute;
    right: -18px;
    top: 15px;
    border-style: dashed solid solid dashed;
    border-color: transparent transparent transparent #fff;
    font-size: 0;
    line-height: 0;
  }
  .phone .item-img  {
    width: 24px;
    height: 24px;
    background: url("../../../static/img/kefu/phone1.png") no-repeat;
  }
  .phone:hover .item-img {
    background: url("../../../static/img/kefu/phone.png") no-repeat;
  }
  .phone:hover .phone-box {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/customerService.vue